<template>
  <div>
    <div class="px-6 pb-12">
      <div>
        <label class="text-lg font-semibold text-black mb-0"
          >Landing Page Name</label
        >
        <el-input
          placeholder="Enter Landing Page Name"
          v-model="pageName"
          class="w-full mt-2"
          @change="validatePageName"
        ></el-input>
        <p class="text-danger mt-1" v-if="isShowErrorPageName">
          This field is required
        </p>
      </div>
      <div class="mt-6" v-if="templateName == 'temp1'">
        <label class="text-lg font-semibold text-black mb-0"
          >Banner Image</label
        >
        <div v-if="editBannerImage">
          <div
            class="h250px relative mt-4"
            v-if="editlanding && editlanding.bannerImage"
          >
            <img
              :src="imageURL + editlanding.bannerImage"
              alt="imagepreview"
              class="w-full h-full rounded-lg"
            />
            <div class="absolute topright10" @click="removeEditBanner">
              <feather-icon icon="XIcon" class="text-white cursor-pointer" />
            </div>
          </div>
        </div>
        <div v-if="!editBannerImage">
          <el-upload
            class="upload-demo mt-2"
            drag
            :before-upload="bannerImageUpload"
            :on-remove="handleRemove"
            :file-list="fileList"
            accept="image/*"
            :on-change="handleRemove"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div> -->
          </el-upload>
          <p class="text-danger mt-1" v-if="isShowErrorBannerImage">
            This field is required
          </p>
        </div>
        <div
          class="mt-6 grid grid-cols-4 gap-4"
          v-if="renderBannerImage.length > 0"
        >
          <div
            v-for="(item, index) in renderBannerImage"
            class="relative"
            :key="item"
          >
            <img :src="item" class="object-cover imgpre w-full rounded-lg" />

            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer text-white"
                @click="
                  () => {
                    bannerImage.splice(index, 1);
                    renderBannerImage.splice(index, 1);
                  }
                "
              />
            </div>
          </div>
        </div>

        <div class="mt-4">
          <label class="text-lg font-semibold text-black mb-0"
            >Banner Image URL</label
          >

          <el-input
            placeholder="Banner Image URL"
            v-model="bannerImageUrl"
            @change="validateBannerImageURL"
            class="mt-2"
          ></el-input>
          <p class="text-danger mt-1" v-if="isShowErrorBannerImageURL">
            This field is required
          </p>
        </div>
      </div>
      <div class="mt-4" v-else>
        <label class="text-lg font-semibold text-black mb-0"
          >Banner Image</label
        >
        <div v-if="editBannerImage">
          <div
            class="h250px relative mt-4"
            v-if="editlanding && editlanding.bannerImage"
          >
            <img
              :src="imageURL + editlanding.bannerImage"
              alt="imagepreview"
              class="w-full h-full rounded-lg"
            />
            <div class="absolute topright10" @click="removeEditBanner">
              <feather-icon icon="XIcon" class="text-white cursor-pointer" />
            </div>
          </div>
        </div>
        <div v-if="!editBannerImage">
          <el-upload
            class="upload-demo mt-2"
            drag
            :before-upload="bannerImageUpload"
            :on-remove="handleRemove"
            :file-list="fileList"
            thumbnail-mode="true"
            accept="image/*"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div> -->
          </el-upload>
          <p class="text-danger mt-1" v-if="isShowErrorBannerImage">
            This field is required
          </p>
        </div>
        <div class="mt-6 grid grid-cols-4 gap-4">
          <div
            v-for="(item, index) in renderBannerImage"
            class="relative"
            :key="item"
          >
            <img :src="item" class="object-cover imgpre w-full rounded-lg" />

            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer text-white"
                @click="
                  () => {
                    bannerImage.splice(index, 1);
                    renderBannerImage.splice(index, 1);
                  }
                "
              />
            </div>
          </div>
        </div>
        <label class="text-lg font-semibold text-black mb-0"
          >Banner Image URL</label
        >

        <el-input
          placeholder="Banner Image URL"
          class="mt-2"
          v-model="bannerImageUrl"
        ></el-input>
        <p class="text-danger mt-1" v-if="isShowErrorBannerImageURL">
          This field is required
        </p>
        <div class="mt-6">
          <label class="text-lg font-semibold text-black mb-0"
            >Upload Image 1</label
          >
          <div v-if="editImage1" class="mt-2">
            <div
              class="h250px relative mt-4"
              v-if="editlanding && editlanding.landingPageImage1"
            >
              <img
                :src="imageURL + editlanding.landingPageImage1"
                alt="imagepreview"
                class="w-full h-full rounded-lg"
              />
              <div class="absolute topright10" @click="removeEditImage1">
                <feather-icon icon="XIcon" class="text-white cursor-pointer" />
              </div>
            </div>
          </div>
          <div v-if="!editImage1" class="mt-2">
            <el-upload
              class="upload-demo"
              drag
              :before-upload="Image1Upload"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
            <p class="text-danger mt-1" v-if="isShowErrorImage1">
              This field is required
            </p>
          </div>
          <div class="mt-6 grid grid-cols-4 gap-4">
            <div
              v-for="(item, index) in renderImage1"
              class="relative"
              :key="item"
            >
              <img :src="item" class="object-cover imgpre w-full rounded-lg" />

              <div
                class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer text-white"
                  @click="
                    () => {
                      image1.splice(index, 1);
                      renderImage1.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
          </div>
          <label class="text-lg font-semibold text-black mb-0"
            >Image URL 1</label
          >
          <el-input
            placeholder="URL"
            v-model="imageUrl1"
            @change="validateImageURL1"
            class="mt-2"
          ></el-input>
          <p class="text-danger mt-1 fsize12" v-if="isShowErrorImageURL1">
            This field is required
          </p>
        </div>
        <div class="mt-6">
          <label class="text-lg font-semibold text-black mb-0"
            >Upload Image 2</label
          >
          <div v-if="editImage2" class="mt-2">
            <div
              class="h250px relative mt-4"
              v-if="editlanding && editlanding.landingPageImage2"
            >
              <img
                :src="imageURL + editlanding.landingPageImage2"
                alt="imagepreview"
                class="w-full h-full rounded-lg"
              />
              <div class="absolute topright10" @click="removeEditImage2">
                <feather-icon icon="XIcon" class="text-white cursor-pointer" />
              </div>
            </div>
          </div>
          <div v-if="!editImage2" class="mt-2">
            <el-upload
              class="upload-demo"
              drag
              :before-upload="Image2Upload"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
            <p class="text-danger mt-1" v-if="isShowErrorImage2">
              This field is required
            </p>
          </div>
          <div class="mt-6 grid grid-cols-4 gap-4">
            <div
              v-for="(item, index) in renderImage2"
              class="relative"
              :key="item"
            >
              <img :src="item" class="object-cover imgpre w-full rounded-lg" />

              <div
                class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer text-white"
                  @click="
                    () => {
                      image2.splice(index, 1);
                      renderImage2.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
          </div>
          <label class="text-lg font-semibold text-black mb-0"
            >Image URL 2</label
          >
          <el-input
            placeholder="URL"
            v-model="imageUrl2"
            @change="validateImageURL2"
            class="mt-2"
          ></el-input>
          <p class="text-danger mt-1" v-if="isShowErrorImageURL2">
            This field is required
          </p>
        </div>
        <div
          class="mt-6"
          v-if="templateName == 'temp2' || templateName == 'temp4'"
        >
          <label class="text-lg font-semibold text-black mb-0"
            >Upload Image 3</label
          >
          <div v-if="editImage3" class="mt-2">
            <div
              class="h250px relative mt-4"
              v-if="editlanding && editlanding.landingPageImage3"
            >
              <img
                :src="imageURL + editlanding.landingPageImage3"
                alt="imagepreview"
                class="w-full h-full rounded-lg"
              />
              <div class="absolute topright10" @click="removeEditImage3">
                <feather-icon icon="XIcon" class="text-white cursor-pointer" />
              </div>
            </div>
          </div>
          <div v-if="!editImage3" class="mt-2">
            <el-upload
              class="upload-demo"
              drag
              :before-upload="Image3Upload"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
            <p class="text-danger mt-1" v-if="isShowErrorImage3">
              This field is required
            </p>
          </div>
          <div class="mt-6 grid grid-cols-4 gap-4">
            <div
              v-for="(item, index) in renderImage3"
              class="relative"
              :key="item"
            >
              <img :src="item" class="object-cover imgpre w-full rounded-lg" />

              <div
                class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer text-white"
                  @click="
                    () => {
                      image3.splice(index, 1);
                      renderImage3.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
          </div>
          <label class="text-lg font-semibold text-black mb-0"
            >Image URL 3</label
          >
          <el-input
            placeholder="URL"
            v-model="imageUrl3"
            @change="validateImageURL3"
            class="mt-2"
          ></el-input>
          <p class="text-danger mt-1" v-if="isShowErrorImageURL3">
            This field is required
          </p>
        </div>
      </div>
      <div class="mt-4 grid grid-cols-4 gap-4" v-if="datavalue.length > 0">
        <div v-for="(item, index) in datavalue" class="relative" :key="item">
          <img
            v-if="editL === true"
            :src="
              'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/' + item
            "
            class="object-cover imgpre w-full rounded-lg"
          />

          <div
            class="absolute top-0 w-5 h-5 flex items-center justify-center rounded-full cursor-pointer right-0"
          >
            <feather-icon
              icon="XIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer text-white"
              @click="
                () => {
                  datavalue.splice(index, 1);
                  renderedmultipleImage.splice(index, 1);
                }
              "
            />
          </div>
        </div>
      </div>
      <div class="mt-4">
        <label class="text-lg font-semibold text-black mb-0">Content</label>
        <div class="mt-2">
          <vue-editor
            class="quill-height"
            id="body1"
            v-model="content"
            @change="validateContent"
          />
        </div>
        <p class="text-danger mt-1" v-if="isShowErrorContent">
          This field is required
        </p>
      </div>
      <div class="mt-4" v-if="templateName == 'temp3'">
        <label class="text-lg font-semibold text-black mb-0">Content</label>
        <div class="mt-2">
          <vue-editor
            class="quill-height"
            id="body2"
            v-model="content2"
            @change="validateContent2"
          />
        </div>
        <p class="text-danger mt-1" v-if="isShowErrorContent2">
          This field is required
        </p>
      </div>
    </div>

    <div class="flex w-full justify-center mt-10">
      <vs-button
        v-if="Editdrawer == false"
        class="border-0 w-full absolute bottom-0 right-0 rounded-none font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        @click="addLandingPage"
      >
        Submit
      </vs-button>
      <vs-button
        v-if="Editdrawer"
        class="border-0 rounded-lg font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        @click="editData()"
      >
        Update
      </vs-button>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-quill-editor";
import { mapState } from "vuex";

export default {
  data() {
    return {
      newImages: [],
      pageName: "",
      datavalue: [],
      renderedmultipleImage: [],
      content: "",
      content2: "",
      input: "",
      bannerImageUrl: "",
      editL: false,
      bannerImage: [],
      renderBannerImage: [],
      image1: [],
      image2: [],
      image3: [],
      renderImage1: [],
      renderImage2: [],
      renderImage3: [],
      imageUrl3: "",
      imageUrl2: "",
      imageUrl1: "",
      isShowErrorPageName: false,
      isShowErrorContent: false,
      isShowErrorContent2: false,
      isShowErrorBannerImageURL: false,
      isShowErrorImageURL1: false,
      isShowErrorImageURL2: false,
      isShowErrorImageURL3: false,
      isShowErrorBannerImage: false,
      isShowErrorImage1: false,
      isShowErrorImage2: false,
      isShowErrorImage3: false,
    };
  },
  props: {
    editlanding: { type: Object },
    clearData: { type: Object },
    Editdrawer: { type: Boolean },
  },
  components: {
    VueEditor,
  },
  methods: {
    validatePageName() {
      if (this.pageName == "") {
        this.isShowErrorPageName = true;
      } else {
        this.isShowErrorPageName = false;
      }
    },
    validateBannerImageURL() {
      if (this.bannerImageUrl == "") {
        this.isShowErrorBannerImageURL = true;
      } else {
        this.isShowErrorBannerImageURL = false;
      }
    },
    validateImageURL1() {
      if (this.imageUrl1 == "") {
        this.isShowErrorImageURL1 = true;
      } else {
        this.isShowErrorImageURL1 = false;
      }
    },
    validateImageURL2() {
      if (this.imageUrl2 == "") {
        this.isShowErrorImageURL2 = true;
      } else {
        this.isShowErrorImageURL2 = false;
      }
    },
    validateImageURL3() {
      if (this.imageUrl3 == "") {
        this.isShowErrorImageURL3 = true;
      } else {
        this.isShowErrorImageURL3 = false;
      }
    },
    validateContent() {
      if (this.content == "") {
        this.isShowErrorContent = true;
      } else {
        this.isShowErrorContent = false;
      }
    },
    validateContent2() {
      if (this.content2 == "") {
        this.isShowErrorContent2 = true;
      } else {
        this.isShowErrorContent2 = false;
      }
    },
    handleRemove(file, filelist) {
      console.log(file, "removed file");
      console.log(filelist, "removed file");
    },
    removeEditBanner() {
      this.$store.state.landingPage.editBannerImage = false;
    },
    removeEditImage3() {
      this.$store.state.landingPage.editImage3 = false;
    },
    removeEditImage2() {
      this.$store.state.landingPage.editImage2 = false;
    },
    removeEditImage1() {
      this.$store.state.landingPage.editImage1 = false;
    },
    async Image1Upload(file) {
      if (this.image1.length < 1) {
        this.image1.push(file);
      } else {
        this.image1.shift(file);
      }

      this.renderImage1Upload(file);
    },
    async renderImage1Upload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderImage1.length < 1) {
          this.$emit("load", this.renderImage1.push(e.target.result));
        } else {
          this.$emit("load", this.renderImage1.shift(e.target.result));
        }
      };
      reader.readAsDataURL(file);
    },
    async Image2Upload(file) {
      if (this.image2.length < 1) {
        this.image2.push(file);
      } else {
        this.image2.shift(file);
      }

      this.renderImage2Upload(file);
    },
    async renderImage2Upload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderImage2.length < 1) {
          this.$emit("load", this.renderImage2.push(e.target.result));
        } else {
          this.$emit("load", this.renderImage2.shift(e.target.result));
        }
      };
      reader.readAsDataURL(file);
    },
    async Image3Upload(file) {
      if (this.image3.length < 1) {
        this.image3.push(file);
      } else {
        this.image3.shift(file);
      }

      this.renderImage3Upload(file);
    },
    async renderImage3Upload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderImage3.length < 1) {
          this.$emit("load", this.renderImage3.push(e.target.result));
        } else {
          this.$emit("load", this.renderImage3.shift(e.target.result));
        }
      };
      reader.readAsDataURL(file);
    },
    async bannerImageUpload(file) {
      if (this.bannerImage.length < 1) {
        this.bannerImage.push(file);
      } else {
        this.bannerImage.shift(file);
      }

      this.renderBannerImageUpload(file);
    },
    async renderBannerImageUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderBannerImage.length < 1) {
          this.$emit("load", this.renderBannerImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderBannerImage.shift(e.target.result));
        }
      };
      reader.readAsDataURL(file);
    },
    async multipleimages(file) {
      if (this.Editdrawer == false) {
        this.newImages.push(file);
      } else {
        if (this.datavalue.length + this.newImages.length < this.imageLimit) {
          this.newImages.push(file);
        } else {
          console.log("image limit exceded");
        }
      }
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < this.imageLimit) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },

    async editData() {
      let validationResponse = this.editFormValidation;
      if (validationResponse) {
        const payload = new FormData();
        payload.append("_id", this.id);
        payload.append("pageName", this.pageName);
        payload.append("content", this.content);
        payload.append("content2", this.content2);
        if (this.bannerImage.length > 0) {
          for (let i in this.bannerImage) {
            payload.append("bannerImage", this.bannerImage[i]);
          }
        }
        if (this.image1.length > 0) {
          for (let i in this.image1) {
            payload.append("landingPageImage1", this.image1[i]);
          }
        }
        if (this.image2.length > 0) {
          for (let i in this.image2) {
            payload.append("landingPageImage2", this.image2[i]);
          }
        }
        if (this.image3.length > 0) {
          for (let i in this.image3) {
            payload.append("landingPageImage3", this.image3[i]);
          }
        }
        if (this.imageUrl1) {
          payload.append("url1", this.imageUrl1);
        }
        if (this.imageUrl2) {
          payload.append("url2", this.imageUrl2);
        }
        if (this.image3) {
          payload.append("url3", this.imageUrl3);
        }
        if (this.bannerImageUrl) {
          payload.append("bannerUrl", this.bannerImageUrl);
        }

        let { data } = await this.$store.dispatch(
          "landingPage/editLandingPage",
          payload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.$emit("updateUiDrawer", false);
        this.getAll();
      } else {
        if (this.templateName == "temp1") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.editBannerImage == false && this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
        }
        if (this.templateName == "temp2" || this.templateName == "temp4") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.imageUrl3 == "") {
            this.isShowErrorImageURL3 = true;
          }
          if (this.imageUrl1 == "") {
            this.isShowErrorImageURL1 = true;
          }
          if (this.imageUrl2 == "") {
            this.isShowErrorImageURL2 = true;
          }
          if (this.editBannerImage == false && this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
          if (this.editImage1 == false && this.image1.length == 0) {
            this.isShowErrorImage1 = true;
          }
          if (this.editImage2 == false && this.image2.length == 0) {
            this.isShowErrorImage2 = true;
          }
          if (this.editImage3 == false && this.image3.length == 0) {
            this.isShowErrorImage3 = true;
          }
        }
        if (this.templateName == "temp3") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.imageUrl1 == "") {
            this.isShowErrorImageURL1 = true;
          }
          if (this.imageUrl2 == "") {
            this.isShowErrorImageURL2 = true;
          }
          if (this.editBannerImage == false && this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
          if (this.editImage1 == false && this.image1.length == 0) {
            this.isShowErrorImage1 = true;
          }
          if (this.editImage2 == false && this.image2.length == 0) {
            this.isShowErrorImage2 = true;
          }
        }
      }
      // let formData = new FormData();
      // console.log(this.editlanding, "editlanging");
      // let payload = { _id: this.editlanding._id };
      // let imagePayload = { _id: this.editlanding._id };
      // if (this.datavalue !== [...this.editlanding.landingPageImage]) {
      //   Object.assign(imagePayload, { landingPageImage: [...this.datavalue] });
      // }
      // if (this.pageName !== this.editlanding.pageName) {
      //   Object.assign(payload, { pageName: this.pageName });
      // }
      // if (this.content !== this.editlanding.content) {
      //   Object.assign(payload, { content: this.content });
      // }
      // if (this.content2 !== this.editlanding.content2) {
      //   Object.assign(payload, { content2: this.content2 });
      // }

      // // formData.append("_id", this.editlanding._id);
      // // if (this.datavalue !== [...this.editlanding.landingPageImage]) {
      // //   for (let i in this.datavalue) {
      // //     formData.append("landingPageImage", this.datavalue[i]);
      // //   }
      // // }
      // // if (this.pageName !== this.editlanding.pageName) {
      // //   formData.append("pageName", this.pageName);
      // // }
      // // if (this.content !== this.editlanding.content) {
      // //   formData.append("content", this.content);
      // // }
      // // if (this.content2 !== this.editlanding.content2) {
      // //   formData.append("content2", this.content2);
      // // }
      // if (imagePayload) {
      //   let keys = Object.keys(imagePayload);
      //   let values = Object.values(imagePayload);
      //   for (let i = 0; i < keys.length; i++) {
      //     if (keys[i] && values[i]) {
      //       formData.append(keys[i], values[i]);
      //       console.log(keys[i], values[i], "Helloz");
      //     }
      //   }
      //   let { data } = await this.$store.dispatch(
      //     "landingPage/editLandingPage",
      //     formData,
      //     {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     }
      //   );
      // }
      // let { data } = await this.$store.dispatch(
      //   "landingPage/editLandingPage",
      //   payload
      // );
    },

    async addLandingPage() {
      let validationResponse = this.editFormValidation;
      if (validationResponse) {
        const payload = new FormData();
        payload.append("pageName", this.pageName);
        payload.append("content", this.content);
        payload.append("content2", this.content2);
        payload.append("type", this.templateName);
        payload.append("bannerUrl", this.bannerImageUrl);
        for (let i in this.bannerImage) {
          payload.append("bannerImage", this.bannerImage[i]);
        }
        if (this.templateName == "temp2" || this.templateName == "temp4") {
          for (let i in this.image1) {
            payload.append("landingPageImage1", this.image1[i]);
          }
          for (let i in this.image2) {
            payload.append("landingPageImage2", this.image2[i]);
          }
          for (let i in this.image3) {
            payload.append("landingPageImage3", this.image3[i]);
          }
          payload.append("url1", this.imageUrl1);
          payload.append("url2", this.imageUrl2);
          payload.append("url3", this.imageUrl3);
        }

        if (this.templateName == "temp3") {
          for (let i in this.image1) {
            payload.append("landingPageImage1", this.image1[i]);
          }
          for (let i in this.image2) {
            payload.append("landingPageImage2", this.image2[i]);
          }
          payload.append("url1", this.imageUrl1);
          payload.append("url2", this.imageUrl2);
        }
        // console.log(payload, "ttrf5rfr");
        let { data } = await this.$store.dispatch(
          "landingPage/addLandingPage",
          payload
        );

        if (data.type == "temp1") {
          let url = `${window.document.location.origin}/blog?lid=${data.short}`;
          const payload = {
            id: data._id,
            fullURL: url,
          };
          let update = await this.$store.dispatch(
            "landingPage/updateFullURL",
            payload
          );
          if (update.data) {
            await this.popup();
          }
        }
        if (data.type == "temp2") {
          let url = `${window.document.location.origin}/blog2?lid=${data.short}`;
          const payload = {
            id: data._id,
            fullURL: url,
          };
          let update = await this.$store.dispatch(
            "landingPage/updateFullURL",
            payload
          );
          if (update.data) {
            await this.popup();
          }
        }
        if (data.type == "temp3") {
          let url = `${window.document.location.origin}/blog3?lid=${data.short}`;
          const payload = {
            id: data._id,
            fullURL: url,
          };
          let update = await this.$store.dispatch(
            "landingPage/updateFullURL",
            payload
          );
          if (update.data) {
            await this.popup();
          }
        }
        if (data.type == "temp4") {
          let url = `${window.document.location.origin}/blog4?lid=${data.short}`;
          const payload = {
            id: data._id,
            fullURL: url,
          };
          let update = await this.$store.dispatch(
            "landingPage/updateFullURL",
            payload
          );
          if (update.data) {
            await this.popup();
          }
        }
        this.pageName = "";
        this.content = "";
        this.content2 = "";
        this.bannerImageUrl = "";
        this.imageUrl1 = "";
        this.imageUrl2 = "";
        this.imageUrl3 = "";
        this.bannerImage = [];
        this.renderBannerImage = [];
        this.image1 = [];
        this.renderImage1 = [];
        this.image2 = [];
        this.renderImage2 = [];
        this.image3 = [];
        this.renderImage3 = [];
        // this.$emit("closePopup");
      } else {
        if (this.templateName == "temp1") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
        }
        if (this.templateName == "temp2" || this.templateName == "temp4") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.imageUrl3 == "") {
            this.isShowErrorImageURL3 = true;
          }
          if (this.imageUrl1 == "") {
            this.isShowErrorImageURL1 = true;
          }
          if (this.imageUrl2 == "") {
            this.isShowErrorImageURL2 = true;
          }
          if (this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
          if (this.image1.length == 0) {
            this.isShowErrorImage1 = true;
          }
          if (this.image2.length == 0) {
            this.isShowErrorImage2 = true;
          }
          if (this.image3.length == 0) {
            this.isShowErrorImage3 = true;
          }
        }
        if (this.templateName == "temp3") {
          if (this.pageName == "") {
            this.isShowErrorPageName = true;
          }
          if (this.content == "") {
            this.isShowErrorContent = true;
          }
          if (this.content2 == "") {
            this.isShowErrorContent2 = true;
          }
          if (this.bannerImageUrl == "") {
            this.isShowErrorBannerImageURL = true;
          }
          if (this.imageUrl1 == "") {
            this.isShowErrorImageURL1 = true;
          }
          if (this.imageUrl2 == "") {
            this.isShowErrorImageURL2 = true;
          }
          if (this.bannerImage.length == 0) {
            this.isShowErrorBannerImage = true;
          }
          if (this.image1.length == 0) {
            this.isShowErrorImage1 = true;
          }
          if (this.image2.length == 0) {
            this.isShowErrorImage2 = true;
          }
        }
      }
    },

    popup() {
      this.$swal({
        text: "Landing page added succesfully",
        icon: "success",
        confirmButtonColor: "#830c81",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Okay",
      });
      this.$emit("closePopup");
    },

    reset() {
      this.datavalue = [];
      this.renderedmultipleImage = [];
      if (this.templateName) {
        this.datavalue = [];
        this.renderedmultipleImage = [];
      }
    },
    async getAll() {
      await this.$store.dispatch("landingPage/getAllLandingPage");
    },
  },
  computed: {
    ...mapState("landingPage", [
      "templateName",
      "imageLimit",
      "editBannerImage",
      "editImage1",
      "editImage2",
      "editImage3",
    ]),
    imageURL() {
      return process.env.VUE_APP_IMAGE_URL;
    },
    editFormValidation() {
      if (this.templateName == "temp1") {
        return (
          this.pageName != "" &&
          this.content != "" &&
          this.content2 != "" &&
          this.bannerImageUrl != ""
        );
      }
      if (this.templateName == "temp2" || this.templateName == "temp4") {
        return (
          this.pageName != "" &&
          this.content != "" &&
          this.content2 != "" &&
          this.bannerImageUrl != "" &&
          this.imageUrl1 != "" &&
          this.imageUrl2 != "" &&
          this.imageUrl3 != ""
        );
      }
      if (this.templateName == "temp3") {
        return (
          this.pageName != "" &&
          this.content != "" &&
          this.content2 != "" &&
          this.bannerImageUrl != "" &&
          this.imageUrl1 != "" &&
          this.imageUrl2 != ""
        );
      }
      if (this.templateName == "temp1" && this.editBannerImage == false) {
        return this.bannerImage.length > 0;
      }
      if (this.templateName == "temp2" && this.editBannerImage == false) {
        return this.bannerImage.length > 0;
      }
      if (this.templateName == "temp2" && this.editImage1 == false) {
        return this.image1.length > 0;
      }
      if (this.templateName == "temp2" && this.editImage2 == false) {
        return this.image2.length > 0;
      }
      if (this.templateName == "temp2" && this.editImage3 == false) {
        return this.image3.length > 0;
      }
      if (this.templateName == "temp4" && this.editBannerImage == false) {
        return this.bannerImage.length > 0;
      }
      if (this.templateName == "temp4" && this.editImage1 == false) {
        return this.image1.length > 0;
      }
      if (this.templateName == "temp4" && this.editImage2 == false) {
        return this.image2.length > 0;
      }
      if (this.templateName == "temp4" && this.editImage3 == false) {
        return this.image3.length > 0;
      }
      if (this.templateName == "temp3" && this.editBannerImage == false) {
        return this.bannerImage.length > 0;
      }
      if (this.templateName == "temp3" && this.editImage1 == false) {
        return this.image1.length > 0;
      }
      if (this.templateName == "temp3" && this.editImage2 == false) {
        return this.image2.length > 0;
      }
    },
  },

  watch: {
    clearData(newvalue) {
      this.id = "";
      this.pageName = "";
      this.content = "";
      this.content2 = "";
      this.type = "";
      this.datavalue = [];
    },
    drawer() {
      if (!this.Editdrawer) {
        this.id = "";
        this.pageName = "";
        this.content = "";
        this.content2 = "";
        this.type = "";
        this.editL = false;
      }
    },
    editlanding(newValue) {
      if (this.Editdrawer) {
        this.id = "";
        this.pageName = "";
        this.content = "";
        this.content2 = "";
        this.type = "";
        this.datavalue = [];
        this.id = newValue._id;
        this.pageName = newValue.pageName;
        this.content = newValue.content;
        this.content2 = newValue.content2;
        this.type = newValue.type;
        this.datavalue = [...newValue.landingPageImage];
      }
      console.log(newValue, "omkarkadu");
    },
  },
  mounted() {
    this.getAll();
    this.datavalue = [];
    this.renderedmultipleImage = [];
    this.isShowErrorPageName = false;
    this.isShowErrorContent = false;
    this.isShowErrorContent2 = false;
    this.isShowErrorBannerImageURL = false;
    this.isShowErrorImageURL1 = false;
    this.isShowErrorImageURL2 = false;
    this.isShowErrorImageURL3 = false;
    this.isShowErrorBannerImage = false;
    this.isShowErrorImage1 = false;
    this.isShowErrorImage2 = false;
    this.isShowErrorImage3 = false;
    if (this.editlanding) {
      this.editL = true;
      this.id = this.editlanding._id;
      this.pageName = this.editlanding.pageName;
      this.content = this.editlanding.content;
      this.content2 = this.editlanding.content2;
      this.type = this.editlanding.type;
      this.bannerImageUrl = this.editlanding.bannerUrl;
      this.datavalue = [...this.editlanding.landingPageImage];
    } else {
      this.editL = false;
    }
    console.log(this.editlanding);
  },
};
</script>
